import { stepToTrackingNameMap } from '@/stepMappings'
import { useCurrentRoute } from '@/redux/signup/selectors'

const useTrackingScreenTitle = () => {
  const currentRoute = useCurrentRoute()

  return stepToTrackingNameMap[currentRoute?.componentKey]
}

export default useTrackingScreenTitle
